import Modal from '../../components/Modal'
import Close from '../../assets/icons/Close'

interface AddResidentConfirmationModalProps {
  isOpen: boolean
  onConfirm: () => void
  onCancel: () => void
  email: string
}

const AddResidentConfirmationModal = ({
  isOpen,
  onConfirm,
  onCancel,
  email,
}: AddResidentConfirmationModalProps) => {
  if (!isOpen) return null
  return (
    <Modal open={isOpen} close={onCancel}>
      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]">
        <div className="bg-white p-6 rounded-[10px]  w-[673px] h-[226px] shadow-xl">
          <div className="flex justify-between">
            <h2 className="text-xl font-semibold mb-6">Add new resident</h2>
            <div className="text-[#ADB5BD]" onClick={onCancel}>
              <Close />
            </div>
          </div>
          <p className="mb-6 text-[#6C757D] font-medium text-lg">
            You have successfully added {email} as a resident, login details has been sent
            to his email.
          </p>
          <hr className="-mx-6 border-t border-[#DEE2E6]" />
          <div className="flex justify-end space-x-2 mt-4">
            <button
              onClick={onCancel}
              className="px-4 py-2 rounded border border-[#CED4DA]"
            >
              Close
            </button>
            <button
              onClick={onConfirm}
              className="px-4 py-2 rounded bg-[#212529] text-white"
            >
              Add new resident
            </button>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default AddResidentConfirmationModal
